const CommonTouchFieldForEdit = <T extends Record<string, any>>({
  dirtyFields,
  currentValues,
  existingValues,
}: {
  dirtyFields: Partial<Readonly<T>>;
  currentValues: T;
  existingValues: T;
}) => {
  const editFields = Object?.keys(dirtyFields)?.reduce(
    (
      acc: {
        [key: string]: string | number;
      },
      key
    ) => {
      if (currentValues[key] !== existingValues[key]) {
        acc[key] = currentValues[key];
      }
      return acc;
    },
    {}
  );
  return editFields;
};

export default CommonTouchFieldForEdit;
